"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformCollectionResponse = void 0;

var _normalizr = require("normalizr");

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _transformationUtils = require("@eb/transformation-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Transforms a given user's collections
// into a normalized by id object.
//
// example URL which response this util handles:
//  /api/v3/destination/collections/?filter=can_curate&user_id=userId
var transformCollectionResponse = function transformCollectionResponse() {
  var collectionData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!collectionData || (0, _isEmpty.default)(collectionData)) {
    return {
      hasMoreItems: '',
      continuation: '',
      entities: {}
    };
  }

  var _collectionData$colle = collectionData.collections,
      collectionsFromResponse = _collectionData$colle === void 0 ? {} : _collectionData$colle,
      _collectionData$pagin = collectionData.pagination,
      pagination = _collectionData$pagin === void 0 ? {} : _collectionData$pagin;
  var content = new _normalizr.Schema('collections');
  /* Parse the events into by ID entities */

  var _transformUtil = (0, _transformationUtils.transformUtil)({
    response: {
      collections: collectionsFromResponse
    },
    schema: {
      collections: (0, _normalizr.arrayOf)(content)
    }
  }),
      _transformUtil$entiti = _transformUtil.entities;

  _transformUtil$entiti = _transformUtil$entiti === void 0 ? {} : _transformUtil$entiti;
  var collections = _transformUtil$entiti.collections;
  var hasMoreItems = pagination.has_more_items,
      continuation = pagination.continuation;
  return {
    hasMoreItems: hasMoreItems,
    continuation: continuation,
    entities: collections
  };
};

exports.transformCollectionResponse = transformCollectionResponse;
//# sourceMappingURL=utils.js.map